import $ from 'jquery';
import Util from 'root/module/util';

export default {
    init: function() {
        this.setEvents();
    },

    setEvents: function() {
        $(document).on('click',     'input[type="checkbox"] + label',         this.events.labelClick);
        $(document).on('click',     'input[type="radio"] + label',            this.events.labelClick);
        $(document).on('submit',    'form',                                   this.events.formSubmit);
        $(document).on('keyup',     'input.colour',                           this.events.colourUpdate);
        $(document).on('focus',     'input.colour',                           this.events.colourFocus);
        $(document).on('click',     'input.colour',                           this.events.colourFocus);
        $(document).on('click',     '.colour-indicator',                      this.events.colourFocus);
        $(document).on('focus',     'form input, form textarea',              this.events.inputFocus);
        $(document).on('change',    'form input, form textarea',              this.events.inputChange);
        $(document).on('blur',      'form input, form textarea',              this.events.inputBlur);
        $(document).on('click',     'form span.placeholder',                  this.events.placeholderClick);
        $(document).on('input',     'input[maxlength],textarea[maxlength]',   this.events.updateMaxLength);
        $(document).on('paste',     '.code-input > input',                    this.events.onCodeInputPaste);
        $(document).on('keyup',     '.code-input > input',                    this.events.onCodeInputKeyUp);
        $(document).on('click',     '.input-subdomain',                       this.events.onSubdomainClick);
    },

    // DOM events
    events: {
        formSubmit: function(e) {
            // handle all forx via XHR
            e.preventDefault();
        },

        labelClick: function(e) {
            if ($(this).attr('for')) {
                return;
            }

            var input = $(this).prev();

            if (!input.prop('disabled') && !input.prop('readonly') && (input.attr('type') === 'checkbox' || !input.prop('checked'))) {
                input.prop('checked', !input.prop('checked'));
            }
        },

        placeholderClick: function(e) {
            $(this).next('input, textarea').focus();
        },

        inputFocus: function(e) {
            var input_type = $(e.currentTarget).attr('type');

            if (input_type === 'checkbox' || input_type === 'radio') {
                return;
            }

            $(e.currentTarget).prev('span.helper').addClass('focus');

            if ($(e.currentTarget).attr('placeholder')) {
                return;
            }

            $(e.currentTarget).prev('span.helper').addClass('focus').removeClass('placeholder');
        },

        inputChange: function(e) {
            var input_type = $(e.currentTarget).attr('type');

            if (input_type === 'checkbox' || input_type === 'radio') {
                return;
            }

            if ($(e.currentTarget).attr('placeholder')) {
                return;
            }

            if ($(e.currentTarget).val()) {
                $(e.currentTarget).prev('span.helper').removeClass('placeholder');
            } else {
                $(e.currentTarget).prev('span.helper').addClass('placeholder');
            }
        },

        inputBlur: function(e) {
            var input_type = $(e.currentTarget).attr('type');

            if (input_type === 'checkbox' || input_type === 'radio') {
                return;
            }

            var val = $(e.currentTarget).val();
            var nonempty = $(e.currentTarget).data('nonempty');

            if (val && nonempty) {
                var nonempty_val = val.trim();

                $(e.currentTarget).val(nonempty_val);
            }

            $(e.currentTarget).prev('span.helper').removeClass('focus');

            if ($(e.currentTarget).attr('placeholder')) {
                return;
            }

            if (!val) {
                $(e.currentTarget).prev('span.helper').addClass('placeholder');
            }
        },

        colourFocus: function(e) {
            $('.colour-picker').remove();

            var input = $(e.currentTarget);

            if (input.hasClass('colour-indicator')) {
                input = input.prev('input.colour');

                if (!input.length) {
                    return;
                }
            }

            if (input.hasClass('colour')) {
                // activate colour picker
                var colour_palette = [
                    '#000000','#444444','#5B5B5B','#999999','#BCBCBC','#EEEEEE','#F3F6F4','#FFFFFF',
                    '#FF7D93','#FFD47D','#FFA97D','#52D4A9','#7DD4EA','#7DA9FF','#937DFF','#93A9BE',
                    '#FF5F79','#FFCA5F','#FF945F','#29CA94','#5FCAE5','#5F94FF','#795FFF','#7994AF',
                    '#FF4060','#FFC040','#FF8040','#00C080','#40C0E0','#4080FF','#6040FF','#6080A0',
                    '#D63651','#D6A136','#D66C36','#00A16C','#36A1BC','#366CD6','#5136D6','#516C86',
                    '#AD2C41','#AD832C','#AD572C','#008357','#2C8398','#2C57AD','#412CAD','#41576D',
                    '#852132','#856421','#854321','#006443','#216474','#214385','#322185','#324353',
                    '#5C1723','#5C4517','#5C2E17','#00452E','#174551','#173E5C','#23175C','#232E3A'];
                var colour_picker = $('<div>').addClass('colour-picker');

                var original_colour = input.val();

                var colour_picker_direction = input.data('direction') || 'down'; // up, down

                colour_picker.attr('data-direction', colour_picker_direction);

                $(colour_palette).each(function() {
                    var colour = this;

                    var colour_palette_select = $('<div>').css('background-color', colour);
                    colour_picker.append(colour_palette_select);

                    colour_palette_select.on('mouseenter', function() {
                        input.val(colour).trigger('keyup');
                    });


                    colour_palette_select.on('click', function(e) {
                        e.stopPropagation();

                        input.val(colour).trigger('keyup');
                        input.val(colour).trigger('input');
                        colour_picker.remove();
                    });
                });

                colour_picker.on('mouseleave', function() {
                    input.val(input.data('keyup_val') || original_colour).trigger('keyup');
                });

                var documentClick = function(e) {
                    if ($(e.target).prop('tagName').toLowerCase() === 'input' && $(e.target).hasClass('colour')) {
                        return;
                    }

                    if ($(e.target).hasClass('colour-picker')) {
                        return;
                    }

                    colour_picker.remove();
                    $(document).off('click', documentClick);
                };

                $(document).on('click', documentClick);

                colour_picker.appendTo($(document.body));

                if (colour_picker_direction === 'up') {
                    colour_picker.css({
                        top:  input.offset().top - colour_picker.outerHeight(),
                        left: input.offset().left
                    });
                } else {
                    colour_picker.css({
                        top:  input.offset().top + input.outerHeight(),
                        left: input.offset().left
                    });
                }
            }
        },

        colourUpdate: function(e) {
            var hex = $(this).val();

            if (Util.isValidHex(hex)) {
                $(this).parent().children('.colour-indicator').css('background-color', hex);

                // is a real keyup event
                if (e.which) {
                    $(this).data('keyup_val', hex);
                }
            } else if (hex === '') {
                $(this).parent().children('.colour-indicator').css('background-color', '');
            }
        },

        updateMaxLength: function(e) {
            var max_length = $(this).attr('maxlength');
            var max_length_helper = $(this).parent().find('.maxlength-help:first');

            if (max_length_helper.length) {
                max_length_helper.text($(e.currentTarget).val().length + ' / ' + max_length);
            }
        },

        onCodeInputPaste: function(e) {
            e.preventDefault();

            var input = $(e.currentTarget);
            var code = e.originalEvent.clipboardData.getData('Text').replace(/ /g, '');

            if (code) {
                $(input).parent().find('input').each(function(i){ $(this).val(code.charAt(i)); })
                $(input).parent().find('input').eq(0).trigger('keyup');
            }
        },

        onCodeInputKeyUp: function(e) {
            var input = $(e.currentTarget);

            var next_input;

            if (e.keyCode === 8 || e.keyCode === 37 || e.keyCode === 38) {
                // 8: back
                // 37: left
                // 38: top
                if (e.keyCode === 8) {
                    input.val('');
                }

                if (input.prev('input').length) {
                    input.prev('input').focus();
                }

                return;
            }

            if (e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 46) {
                // 39: right
                // 40: down
                // 46: delete

                if (e.keyCode === 46) {
                    input.val('');
                }

                if (input.next('input').length) {
                    input.next('input').focus();
                }

                return;
            }

            $(input).parent().find('input').each(function() {
                var val = $(this).val();

                if (!val) {
                    next_input = $(this);
                    return false;
                }
            });

            if (next_input) {
                next_input.focus();
                return;
            }

            $(input).parents('form:first').trigger('submit');
        },

        onSubdomainClick: function(e) {
            var tag_name = $(e.target).prop('tagName').toLowerCase();

            if (tag_name !== 'input') {
                $(e.currentTarget).find('input').focus();
            }
        }
    },

    // API Methods
    setPlaceholder: function(form) {
        form.find('span.helper').each(function() {
            var input = $(this).next('input, textarea');

            if (input.length && !input.val() && !input.attr('placeholder')) {
                $(this).addClass('placeholder');
            }
        });

        // check autofill
        var interval_id = setInterval(function() {
            try {
                var autofill_fields = form.find(':-webkit-autofill');

                if (autofill_fields.length) {
                    autofill_fields.prev('span.helper').removeClass('placeholder');
                    clearInterval(interval_id);
                }
            } catch (e) {
                clearInterval(interval_id);
            }
        }, 50);

        // clear interval one sec later
        setTimeout(function() {
            clearInterval(interval_id);
        }, 2000);
    },

    getData: function(form, key) {
        var form_data = {};

        form.find('input, select, textarea').each(function() {
            var key = $(this).attr('name');

            if (key) {
                if ($(this).attr('type') === 'checkbox') {
                    if (!form_data[key]) {
                        form_data[key] = [];
                    }

                    if ($(this).is(':checked')) {
                        var value = $(this).val();
                        form_data[key].push(Util.isNumeric(value) ? parseInt(value, 10) : value);
                    }
                } else if ($(this).attr('type') === 'radio') {
                    var checked_element = form.find('[name="' + key + '"]:checked');

                    if (checked_element.length) {
                        var value = checked_element.val();
                        form_data[key] = Util.isNumeric(value) ? parseInt(value, 10) : value;
                    } else {
                        form_data[key] = '';
                    }
                } else {
                    var value = $(this).val();
                    if ($(this).data('validation') === 'string') {
                        form_data[key] = value;
                    } else {
                        form_data[key] = Util.isNumeric(value) ? parseInt(value, 10) : value;
                    }
                }
            }
        });

        if (key) {
            return form_data[key];
        } else {
            return form_data;
        }
    },

    setData: function(form, data) {
        $.each(data, function(name, value) {
            var field = form.find('[name="' + name + '"]').eq(0);

            if (field.length) {
                var field_type = field.attr('type');

                if (field_type === 'radio' || field_type === 'checkbox' || field_type === 'hidden') {
                    if (value === true) {
                        value = 1;
                    } else if (value === false) {
                        value = 0;
                    }
                }

                if (field_type === 'radio') {
                    form.find('[name="' + name + '"][value="' + value + '"]').prop('checked', true);
                } else if (field_type === 'checkbox') {
                    form.find('[name="' + name + '"]').each(function() {
                        var checkbox = $(this);
                        var found = false;

                        if (value && Array.isArray(value)) {
                            value.forEach(function(option_val) {
                                if (option_val == checkbox.val()) { // use double equal to compare
                                    found = true;
                                }
                            });
                        }

                        checkbox.prop('checked', found);
                    });
                } else {
                    if (field.hasClass('colour')) {
                        if (!field.next('.colour-indicator').length) {
                            $('<div>').addClass('colour-indicator').insertAfter(field);
                        }

                        field.next('.colour-indicator').css('background-color', value);
                    }

                    field.val(value);
                }

                var max_length = field.attr('maxlength');
                var max_length_helper = field.parent().find('.maxlength-help:first');

                if (max_length && max_length_helper.length) {
                    max_length_helper.text(field.val().length + ' / ' + field.attr('maxlength'));
                }
            }
        });
    }
};
